import { Box, Button } from '@chakra-ui/react'
import React from 'react'
import { MdArrowBack } from 'react-icons/md'


interface SimpleConditionalFrameProps {
    children: React.ReactNode
    backClick: () => void
    title: string
}

export const SimpleConditionalFrame: React.FC<SimpleConditionalFrameProps> = ({ children, backClick, title }) => {
    return (
        <>
            <Box
                w={"100%"}
                h={"16"}
                display={"flex"}
                alignItems={"center"}
                p={4}
                gap={4}
                mb={4}
                backgroundColor={"gray.100"}
                borderRadius={"lg"}
            >
                <Button
                    leftIcon={<MdArrowBack />}
                    colorScheme='brand'
                    size={"sm"}
                    borderRadius={'lg'}
                    variant='solid'
                    onClick={backClick}
                >
                    Voltar
                </Button>

                <Box fontSize="xl" fontWeight="bold">
                    {title}
                </Box>
            </Box>

            <Box
                minW={"100%"}
                display={"flex"}
                p={4}
                gap={4}
                mb={4}
                backgroundColor={"gray.100"}
                borderRadius={"lg"}
                overflow={"auto"}
            >
                {children}
            </Box>
        </>
    )
}
